/**
 * Force a layout reflow by reading a layout property on the node.
 * Use after mutating styles so the browser commits layout before the next style change
 * (e.g. so CSS transitions animate from the correct initial state).
 */
export function reflow(node: HTMLElement): void {
  node.scrollTop;
}

/**
 * Read the current translate (x, y) from an element's computed transform.
 * Parses matrix(a, b, c, d, e, f) where e = tx, f = ty.
 * Returns { x: 0, y: 0 } if transform is none or unparseable.
 */
export function getComputedTranslate(
  node: HTMLElement
): { x: number; y: number } {
  const transform = window.getComputedStyle(node).getPropertyValue('transform');
  if (!transform || transform === 'none' || typeof transform !== 'string') {
    return { x: 0, y: 0 };
  }
  const match = transform.match(/matrix.*\((.+)\)/);
  if (!match) return { x: 0, y: 0 };
  const parts = match[1].split(', ');
  return {
    x: parseFloat(parts[4] ?? '0') || 0,
    y: parseFloat(parts[5] ?? '0') || 0,
  };
}
